import { z } from 'zod';
import { ReceivableCurrency, ReceivableStatus, ReceivableStore } from '../utils';

export const receivableFormSchema = z.object({
  currency: z.nativeEnum(ReceivableCurrency, { required_error: 'Selecione a moeda' }),
  status: z.nativeEnum(ReceivableStatus, { required_error: 'Selecione o status' }),
  store: z.nativeEnum(ReceivableStore, { required_error: 'Selecione a loja' }),
  grossValue: z
    .number({ invalid_type_error: 'Informe um número' })
    .min(0, 'Valor não pode ser negativo'),
  relatedDate: z.date({ required_error: 'Informe a data de referência' }),
  paidDate: z.date().optional(),
  receivableShareConfigId: z
    .string({ required_error: 'Selecione uma configuração de rateio' })
    .uuid('Selecione uma configuração válida'),
});

export type ReceivableFormValues = z.infer<typeof receivableFormSchema>;

